const aboutSectionStyle = {
    content: {
        "& p": {
            fontSize: '1.0625rem',
            lineHeight: '1.55em',
            marginTop: '10px',
            marginBotton: '10px',
            color: '#000',
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            fontWeight: 300
        }
    }
}

export default aboutSectionStyle;